<script lang="ts" setup>
import type { IImportValue } from './IImportValue';

defineProps<{
    value: IImportValue;
}>();
</script>

<template>
    <div>{{ value.Value }}</div>
</template>
